import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'sync-logout',
    templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

    constructor(
        private auth: AuthService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.handleLogout();
    }

    public async handleLogout() {
        await this.auth.logout();
        this.router.navigate(['/login'], { queryParams: this.route.snapshot.queryParams, queryParamsHandling: 'merge' });
    }

}
